__webpack_require__.p = "/energy/paper/Ethanol_Agro_residues/";